const INPUT_EMPTY_MESSAGE = 'Input cannot be empty';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function isRequiredRule(value: any): string | true {
    if (value === undefined || value === null) {
        return INPUT_EMPTY_MESSAGE;
    }

    const isValueNotEmpty = Boolean(value.toString().trim());

    return isValueNotEmpty || INPUT_EMPTY_MESSAGE;
}
